import { render } from "./EmptyState.vue?vue&type=template&id=0073c54a&scoped=true&ts=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=0073c54a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0073c54a"]])

export default __exports__